<template>
  <label class="icon-box" :class="{ disabled }" for="uploadImage" @click="clickFile">
    <auth-img class="icon-img" src="@/assets/img/chat/image.png" alt="" />
    <div class="icon-label">图片</div>
    <input type="file" accept="image/*" v-show="false" ref="imgDom" @change="pictureChange" />
  </label>
</template>

<script setup>
import { defineEmits, defineProps, ref, watch } from 'vue'
import WebIM from '@/utils/WebIM'
import Config from '@/config/index'
import { message } from 'ant-design-vue'
import { useStore } from 'vuex'
import { chatGroupTabsKeyEnum } from '@/utils/globalMap'
const store = useStore()
const props = defineProps({
  customUpload: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  },
  groupTabsSelKey: {
    type: String,
    default: ''
  },
  chatId: {
    type: [String, undefined],
    default: ''
  },
  chatToType: {
    type: String,
    required: true
  }
})
const emit = defineEmits(['select'])
const imgDom = ref(null)
const groupId = ref(props.chatId)
const groupTabsKey = ref(props.groupTabsSelKey)
watch(
  () => props.chatId,
  newValue => {
    groupId.value = newValue
  }
)
watch(
  () => props.groupTabsSelKey,
  newValue => {
    groupTabsKey.value = newValue
  }
)

const clickFile = () => {
  if (props.disabled) return
  imgDom.value.click()
}
// 每次都需要手动清空上次选择的文件，否则无法触发input 的change事件
let TargetVal = ''
const pictureChange = e => {
  TargetVal = e.target
  const file = WebIM.utils.getFileUrl(e.target)
  console.log('用户选择的图片=======>', file)
  if (!file.filename) {
    return false
  }
  if (!Config.IMG_TYPE[file.filetype.toLowerCase()]) {
    message.error('图片格式仅支持png/jpg/jpeg / 图片仅限10M以内')
    return
  }
  if (props.customUpload) {
    emit('select', { file: e.target.files[0], fileInfo: file })
    e.target.value = ''
    return
  }
  const obj = {
    chatType: 'group',
    chatId: groupId.value,
    file: file,
    chatToType: props.chatToType,
    ext: {
      is_doctor_private: groupTabsKey.value === chatGroupTabsKeyEnum.医生私聊
    },
    callback: () => {
      TargetVal.value = ''
    }
  }
  store.dispatch('sendImgMessage', obj)
}
</script>
<style lang="scss" scoped>
@import '../../index.scss';

.icon-box.disabled {
  opacity: 0.45;
  cursor: not-allowed;
}
</style>
